import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { PropertyWhatsAround } from '@shared-ui/lodging-property-details';
import { RefTarget } from '@shared-ui/ref-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

const WhatsAroundWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <ErrorBoundary label="hotel.information.whats-around.map">
    <UitkSpacing margin={{ block: 'six' }}>
      <RefTarget name="Location" dataStid="whats-around">
        <SimpleLazyLoadWrapper>
          <PropertyWhatsAround inputs={inputs} />
        </SimpleLazyLoadWrapper>
      </RefTarget>
    </UitkSpacing>
  </ErrorBoundary>
);

// @ts-ignore
export const SharedUiWhatsAroundWrapper = withSharedUiPropertyDetails(WhatsAroundWrapper);
SharedUiWhatsAroundWrapper.displayName = 'SharedUiWhatsAroundWrapper';
